import { RoleWatcher } from "PFApp/activities/types/watchers";
import { TableColumn } from "PFTypes";
import { Meta } from "PFTypes";
import { OrderOptionOrEmpty } from "PFTypes";
import { createContext, Dispatch, SetStateAction, useContext } from "react";

type InterestedContextType = {
  selectedIds: Record<string, true>;
  setSelectedIds: Dispatch<SetStateAction<Record<string, true>>>;
  showTableProperties: boolean;
  setTablePropertiesVisibility: (isVisible: boolean) => void;
  columns: any[];
  selectedColumns: TableColumn[];
  setSelectedColumns: (columnsToStore: TableColumn[]) => void;
  isWatchersLoading: boolean;
  watchersMetadata: Meta | undefined;
  watchers: RoleWatcher[];
  filteredWatchers: RoleWatcher[];
  setSelectedOrder: (order: OrderOptionOrEmpty) => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
};

export const InterestedContext = createContext({} as InterestedContextType);

export const useInterestedContext = () => useContext(InterestedContext);
